import * as auth from './auth';
import * as collaborator from './collaborator';
import * as subscription from './subscription';

export default {auth, collaborator, subscription};
